import React from 'react';
import { Grid, FormControlLabel, Checkbox, FormControl, InputLabel, Select, MenuItem, ListSubheader, FormHelperText, Button } from '@mui/material';
import { nurseGroups } from '../constants/options';

const BeforeInduction = ({ formData, setFormData, errors, setErrors, handleChange, handleCheckboxChange, handleBlur, handleSignatureOpen }) => {
  const handleNameChange = (e) => {
    const regex = /^[a-zA-Z\s.-]*$/;
    const { name, value } = e.target;
    if (value === '' || regex.test(value)) {
      setFormData(prev => ({ ...prev, [name]: value }));
      if (errors[name]) {
        setErrors((prev) => ({ ...prev, [name]: '' }));
      }
    }
  };

  return (
    <>
      <div className="font-semibold mt-2 mb-1">Patient has confirmed</div>
      <FormControlLabel
        control={<Checkbox checked={formData.identity_confirmed} onChange={handleChange} name="identity_confirmed" />}
        label="Identity"
      />
      <FormControlLabel
        control={<Checkbox checked={formData.site_confirmed} onChange={handleChange} name="site_confirmed" />}
        label="Site"
      />
      <FormControlLabel
        control={<Checkbox checked={formData.procedure_confirmed} onChange={handleChange} name="procedure_confirmed" />}
        label="Procedure"
      />
      <FormControlLabel
        control={<Checkbox checked={formData.consent_confirmed} onChange={handleChange} name="consent_confirmed" />}
        label="Consent"
      />
      <hr className="my-2" />
      
      <div className="font-semibold mt-2 mb-1">Site marked</div>
      <FormControlLabel
        control={
          <Checkbox
            checked={formData.site_marked === "yes"}
            onChange={(event) => handleCheckboxChange(event, "yes", "site_marked")}
            name="site_marked_yes"
          />
        }
        label="Site marked"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={formData.site_marked === "no"}
            onChange={(event) => handleCheckboxChange(event, "no", "site_marked")}
            name="site_marked_no"
          />
        }
        label="NA"
      />

      <hr className="my-2" />
      <FormControlLabel control={<Checkbox checked={formData.anesthesia_safety_check} onChange={handleChange} name="anesthesia_safety_check" />} label="Anesthesia safety check completed" />
      <br />
      <FormControlLabel control={<Checkbox checked={formData.pulse_oximeter_functioning} onChange={handleChange} name="pulse_oximeter_functioning" />} label="Pulse oximeter on patient & functioning" />
      
      <div className="font-semibold mt-4 mb-1">Does patient have:</div>

      <div className="font-semibold mt-2 mb-1">Known allergy</div>
      <FormControlLabel
        control={
          <Checkbox
            checked={formData.known_allergy === "yes"}
            onChange={(event) => handleCheckboxChange(event, "yes", "known_allergy")}
            name="known_allergy_yes"
          />
        }
        label="Yes"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={formData.known_allergy === "no"}
            onChange={(event) => handleCheckboxChange(event, "no", "known_allergy")}
            name="known_allergy_no"
          />
        }
        label="No"
      />

      <hr className="my-2" />
      <div className="font-semibold mt-2 mb-1">Difficult airway/aspiration risk?</div>
      <FormControlLabel
        control={
          <Checkbox
            checked={formData.difficult_airway_assistance_available === "yes"}
            onChange={(event) => handleCheckboxChange(event, "yes", "difficult_airway_assistance_available")}
            name="difficult_airway_assistance_available_yes"
          />
        }
        label="Yes, equipment/assistance available"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={formData.difficult_airway_assistance_available === "no"}
            onChange={(event) => handleCheckboxChange(event, "no", "difficult_airway_assistance_available")}
            name="difficult_airway_assistance_available_no"
          />
        }
        label="No"
      />

      <div className="font-semibold mt-2 mb-1">Risk of {'>'}500ml blood loss</div>
      <FormControlLabel
        control={
          <Checkbox
            checked={formData.risk_of_500ml_blood_loss === "yes"}
            onChange={(event) => handleCheckboxChange(event, "yes", "risk_of_500ml_blood_loss")}
            name="risk_of_500ml_blood_loss_yes"
          />
        }
        label="Yes, adequate intravenous access/fluids planned"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={formData.risk_of_500ml_blood_loss === "no"}
            onChange={(event) => handleCheckboxChange(event, "no", "risk_of_500ml_blood_loss")}
            name="risk_of_500ml_blood_loss_no"
          />
        }
        label="No"
      />

      <div className="font-semibold mt-2 mb-1">Blood stand by kept</div>
      <FormControlLabel
        control={
          <Checkbox
            checked={formData.adequate_iv_fluids_planned === "yes"}
            onChange={(event) => handleCheckboxChange(event, "yes", "adequate_iv_fluids_planned")}
            name="adequate_iv_fluids_planned_yes"
          />
        }
        label="Yes"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={formData.adequate_iv_fluids_planned === "no"}
            onChange={(event) => handleCheckboxChange(event, "no", "adequate_iv_fluids_planned")}
            name="adequate_iv_fluids_planned_no"
          />
        }
        label="No"
      />
      
      <div className="font-semibold mt-2 mb-1">Serology status done</div>
      <FormControlLabel
        control={
          <Checkbox
            checked={formData.serology_status_negative}
            onChange={(event) => {
              if (event.target.checked) {
                setFormData(prev => ({ ...prev, serology_status_negative: true, serology_status_positive: false }));
              } else {
                setFormData(prev => ({ ...prev, serology_status_negative: false }));
              }
            }}
            name="serology_status_negative"
          />
        }
        label="Negative"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={formData.serology_status_positive}
            onChange={(event) => {
              if (event.target.checked) {
                setFormData(prev => ({ ...prev, serology_status_positive: true, serology_status_negative: false }));
              } else {
                setFormData(prev => ({ ...prev, serology_status_positive: false }));
              }
            }}
            name="serology_status_positive"
          />
        }
        label="Positive"
      />

      <hr className="my-2" />
      <div className="font-bold text-center mt-4">OT NURSE</div>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl fullWidth sx={{ marginTop: 1 }}>
            <InputLabel id="ot_nurse_name-label">Name (NURSE)</InputLabel>
            <Select
              labelId="ot_nurse_name-label"
              id="ot_nurse_name"
              name="ot_nurse_name"
              value={formData.ot_nurse_name || ""}
              label="Name (NURSE)"
              onChange={handleNameChange}
              onBlur={handleBlur}
              error={!!errors.ot_nurse_name}
            >
              <MenuItem value="">
                <em>Select Nurse</em>
              </MenuItem>
              {Object.entries(nurseGroups).map(([groupName, nurses]) => [
                <ListSubheader key={groupName}>{groupName}</ListSubheader>,
                nurses.map((nurse, idx) => (
                  <MenuItem key={`${groupName}-${idx}`} value={nurse}>
                    {nurse}
                  </MenuItem>
                ))
              ])}
            </Select>
            {errors.ot_nurse_name && <FormHelperText>{errors.ot_nurse_name}</FormHelperText>}
          </FormControl>

          <Button variant="outlined" color="primary" sx={{ marginTop: 2 }} onClick={() => handleSignatureOpen("ot_nurse_signature")}> 
            Sign Here 
          </Button>
          {formData.ot_nurse_signature && (
            <img 
              src={`data:image/png;base64,${formData.ot_nurse_signature}`} 
              alt="Signature" 
              style={{ marginTop: 10, border: '1px solid black', width: '100%', height: '150px', objectFit: 'contain' }} 
            />
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default BeforeInduction;
